export default __webpack_public_path__ + "static/media/deals.bf44137c.svg";